var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { COMPLETED_STATUS } from "../../../../enum/ai-report";
import { useAiReportStore } from "../../../../store/ai-report/global-store";
import { Alert, Box, Typography } from 'fbm-ui';
var NotFinish = function () {
    var _a = useAiReportStore(function (store) { return [store.reportResult, store.interviewCheat]; }), reportResult = _a.reportResult, interviewCheat = _a.interviewCheat;
    var _b = (reportResult || {}).completedStatus, completedStatus = _b === void 0 ? 1 : _b;
    var _c = interviewCheat || {}, isCheat = _c.isCheat, info = _c.info;
    if (completedStatus === COMPLETED_STATUS.NOT_COMPLETED || isCheat) {
        return (_jsx(Box, __assign({ mb: 2 }, { children: _jsx(Alert, __assign({ type: isCheat ? 'error' : 'warning' }, { children: _jsx(Typography, __assign({ variant: "body2", color: "textSecondary" }, { children: info || '该候选人尚未回答完所有题目，建议提醒候选人完成面试' })) })) })));
    }
    return null;
};
export default NotFinish;
